/**
 * Role Protected Route Component
 * Wraps routes that require specific permissions
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService } from '../../services/auth/AuthService';
import { canManageAdminUsers } from '../../utils/permissions';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  requireAdminUserManagement?: boolean;
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ 
  children, 
  requireAdminUserManagement = false 
}) => {
  const location = useLocation();
  const isAuthenticated = AuthService.isAuthenticated();

  if (!isAuthenticated) {
    // Redirect to login page, saving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check permission if required
  if (requireAdminUserManagement) {
    const hasPermission = canManageAdminUsers();
    if (!hasPermission) {
      // Redirect to dashboard if user doesn't have permission
      console.warn('Access denied: User does not have permission to access admin user management');
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

